import BoxBlock from '../../containers/box/block';
import React from 'react';
import { BlockPropsBase, flattenChildren } from '../..';

const RootContainer = (props: BlockPropsBase) => flattenChildren(props.content).length ? <BoxBlock {...props}/> : null;

export default RootContainer;
